import {Component, EventEmitter, Output} from '@angular/core';
import {PaginationBuilder, PaginationComponent} from '@spartacus/storefront';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'dcp-pagination',
  templateUrl: './dcp-pagination.component.html',
  styleUrls: ['./dcp-pagination.component.scss']
})
export class DcpPaginationComponent extends PaginationComponent {

  @Output() viewPageEvent: EventEmitter<number> = new EventEmitter<number>();

  constructor(
    paginationBuilder: PaginationBuilder,
    activatedRoute: ActivatedRoute
  ) {
    super(paginationBuilder, activatedRoute);
  }

  onChange($event: any): void {
    this.viewPageEvent.emit($event.detail.currentPage - 1);
  }
}
